import { createReducer, on } from "@ngrx/store";
import { LearnerResourcesState, initialLearnerResourceState } from "./learner-resources.state";
import { GetLearnerResources, GetLearnerResourcesError, GetLearnerResourcesSuccess, GetModuleTypesOfResources, GetModuleTypesOfResourcesError, GetModuleTypesOfResourcesSuccess, ResetLearnerResources, UpdateLearnerResources, UpdateLearnerResourcesError, UpdateLearnerResourcesSuccess } from "./learner-resources.actions";

export const LearnerResourcesReducers = createReducer(
  initialLearnerResourceState,
  on(ResetLearnerResources, (): LearnerResourcesState => {
    return initialLearnerResourceState;
  }),
  on(GetModuleTypesOfResources, (state): LearnerResourcesState => {
    return {
      ...state,
      moduleTypes: null,
      moduleTypesLoader: true,
      moduleTypesError: null, 
    }
  }),
  on(GetModuleTypesOfResourcesSuccess, (state, action): LearnerResourcesState => {
    return {
      ...state,
      moduleTypes: action.result,
      moduleTypesLoader: false,
      moduleTypesError: null, 
    }
  }),
  on(GetModuleTypesOfResourcesError, (state, action): LearnerResourcesState => {
    return {
      ...state,
      moduleTypesLoader: false,
      moduleTypesError: action.error, 
    }
  }),
  on(GetLearnerResources, (state): LearnerResourcesState => {
    return {
      ...state,
      learnerResourcesLoader: true,
    }
  }),
  on(GetLearnerResourcesSuccess, (state, action): LearnerResourcesState => {
    return {
      ...state,
      learnerResources: action.result,
      learnerResourcesLoader: false,
      learnerResourcesError: null,
    }
  }),
  on(GetLearnerResourcesError, (state, action): LearnerResourcesState => {
    return {
      ...state,
      learnerResourcesLoader: false,
      learnerResourcesError: action.error,
    }
  }),
  on(UpdateLearnerResources, (state): LearnerResourcesState => {
    return {
      ...state,
      updateLearnerResourcesResult: null,
      updateLearnerResourcesLoader: true,
      updateLearnerResourcesError: null,
    }
  }),
  on(UpdateLearnerResourcesSuccess, (state, action): LearnerResourcesState => {
    return {
      ...state,
      updateLearnerResourcesResult: action.result,
      updateLearnerResourcesLoader: false,
      updateLearnerResourcesError: null,
    }
  }),
  on(UpdateLearnerResourcesError, (state, action): LearnerResourcesState => {
    return {
      ...state,
      updateLearnerResourcesLoader: false,
      updateLearnerResourcesError: action.error,
    }
  }),
);